import React from "react"
import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

import renderIngredientContent from "./ingredientcontent"

const IngredientContainer = styled.div``

const Columns = styled(Flex)`
  flex-wrap: wrap;
  margin: 0 auto;
`

const IngredientSection = styled.section`
  margin: 0;
  > h2 {
    color: ${theme.wild.color.master.base.black};
    text-align: left;
    margin: 24px 0 64px;
    @media (min-width: ${theme.mediaqueries.small}) {
      text-align: center;
      margin: 8px 0 40px;
      padding: 0 80px;
    }
    @media (min-width: ${theme.mediaqueries.medium}) {
      margin: 16px 0 64px;
      padding: 0 200px;
    }
  }

  @media (min-width: 768px) {
    width: 100%;
  }
`

const IngredientContentContainer = styled(Flex)`
  flex-direction: column;
  @media (min-width: ${theme.mediaqueries.small}) {
    flex-direction: row;
  }
`

const IngredientContent = styled.div`
  @media (min-width: 768px) {
    flex: 1;
  }
`

const ListIngredients = ({ content }) => {
  return (
    <IngredientContainer>
      <Columns>
        <IngredientSection>
          <IngredientContentContainer id="ingredients-content-container">
            <IngredientContent>
              {renderIngredientContent(content)}
            </IngredientContent>
          </IngredientContentContainer>
        </IngredientSection>
      </Columns>
    </IngredientContainer>
  )
}

export default ListIngredients
